import { IonCol, IonGrid, IonImg, IonLabel, IonRow } from "@ionic/react";
import { getStopActivity } from "../../../models/stopActivity.model";
import React from "react";
import { EXECUTIONSTATUS } from "../../../utils/constants";
import { checkForDeadHeadWeb, detectSeachPath, convertDeadheadToInt } from '../../../utils/Deadhead'

import "./StopDetails.scss";
import { isEntitled } from "../../../utils/common";
import { ReloadButton } from "../../../components/shared/ReloadButton/ReloadButton";

const StopDetails = (props: any) => {
  const isRecentlyDeliveredLoad = (props?.load) && (props.load.executionStatus === EXECUTIONSTATUS.COMPLETED || props.load.executionStatus === EXECUTIONSTATUS.DELIVERED) || false
  const transportMode = (props?.load) && props.load.transportMode;
  const capacityType = (props?.load) && props.load.capacityType;
  const stopDetail = props.stopDetails;
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: props.costCurrency || 'USD',
    minimumFractionDigits: 0
  });
  const renderDeadHead = () => {
    return (
      <>
      {stopDetail.deadHead !== null &&
        <p className="origin_dateTime load_header_elements stop-appointment">
        Deadhead {`${convertDeadheadToInt(stopDetail.deadHead)} ${props.load.distanceUOM}`}
      </p>
    }
    </>
    );
  }
  return stopDetail ? (
    <IonGrid class="stop-data-grid web-load-grid">
      {props.index < props.length - 1 ? (
        <>
          {props.index === 0 ? (
            <IonImg
              className="stop-icon"
              src="assets/icon/origin-pointer.svg"
            />
          ) : (
              <IonImg className="stop-icon" src="assets/icon/stop-pointer.svg" />
            )}
        </>
      ) : (
          <IonImg className="path_icon" src="assets/icon/dst-pointer.svg" />
        )}
      <IonGrid className="stop-address-grid stop-details-grid">
        <IonRow>
          <IonCol size={props.isTopRecomm?"auto":"5"} size-lg={props.isTopRecomm?"auto":"6"}>
            <p className="origin_city">
              {stopDetail && stopDetail.state === null
                ? stopDetail && stopDetail.city
                : `${stopDetail && stopDetail.city}, ${stopDetail && stopDetail.state}`}
            </p>
            {props.isTopRecomm ? <>
              <div className="margin_height_stop" />
              <p className="origin_dateTime load_header_elements stop-appointment">
                {props.appointment}
              </p>
              <div className="margin_height_stop" />
              <p className={`origin_milehead load_header_elements stop-activity ${props.isTopRecomm ?"stop-activity-top-recommended":""}`}>
                {getStopActivity(
                  (stopDetail && stopDetail.stopActivity) ||
                  (stopDetail && stopDetail.specialServices) ||
                  [],
                  !props.isCarrierLoad,
                  stopDetail.stopType
                )}
              </p>
            </>:null}
          </IonCol>
          {props.isTopRecomm ? null : <IonCol size="7" size-lg="6">
            {props && props.history && (detectSeachPath(props.history.location.pathname) ||
              checkForDeadHeadWeb(props, stopDetail)) || props?.isManageUserAssignedLoad ? (
                <p className="origin_dateTime load_header_elements stop-appointment margin_top">
                  {props.appointment}
                </p>
              ) : null}
            <div className="margin_height_stop" />
            <p className={`origin_milehead load_header_elements stop-activity ${props.isTopRecomm ?"stop-activity-top-recommended":""}`}>
              {getStopActivity(
                (stopDetail && stopDetail.stopActivity) ||
                (stopDetail && stopDetail.specialServices) ||
                [],
                !props.isCarrierLoad,
                stopDetail.stopType
              )}
            </p>
            <div className="margin_height_stop" />
            {props.history  && !detectSeachPath(props.history.location.pathname) &&
            !checkForDeadHeadWeb(props, stopDetail) ? (
              <p className="origin_dateTime load_header_elements stop-appointment">
                {props.appointment}
              </p>
            ) : null}
            {checkForDeadHeadWeb(props, stopDetail) ? renderDeadHead() : null}
            {props.isMyload && isEntitled("myLoad", "rateDetails") && props.isLastElement && !props?.isManageUserAssignedLoad &&
              <div className={"total-rate-label"}>
                <IonLabel className="card_p-elements rate-label-text" data-test="rate-details">
                  Rate:    </IonLabel>
                <IonLabel className="price-label">{props.totalCostAmount!==undefined && props.totalCostAmount!==null ? currencyFormatter.format(Math.trunc(props.totalCostAmount)) : "N/A" }</IonLabel>
              </div>
            }
          </IonCol>}
          {isEntitled("myLoad","reloadButton") && ((!props.isTopRecomm && props.isLastElement) && (stopDetail)) && 
            <ReloadButton 
              isRecommended={(props.load && props.load.loadId) || false} 
              id={(props.load && props.load.loadId) || (props.load && props.load.shipmentId)}
              history={props.history} 
              transportMode={capacityType?capacityType:transportMode} 
              stopDetails={props.load.loadStop} 
              userDetails={props.userDetails} 
              onRedirectToTab={props.onRedirectToTab}
              isRecentlyDelivered={isRecentlyDeliveredLoad}
              recommended={props.recommended || false}
            />}
        </IonRow>
      </IonGrid>
    </IonGrid>
  ) : null;
};

export default StopDetails;